
import React from "react";
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import Toolbar from "../../../components/toolbar/Toolbar";
import { Column } from 'primereact/column';
import { routes } from '../../../constants';
import { Page } from "../../../components/page/Page";
import { SegmentList } from "./SegmentList";
import { actions } from '../segment.actions'
import { AppService, COMPANY_CHANGE_EVENT_NAME, BUSINESS_UNIT_CHANGE_EVENT_NAME } from "../../../services/app.service";


const mapStateToProps = state => {
  return {
    columns: state.crudSegmentState.columns,
    records: state.crudSegmentState.records,
    first: state.crudSegmentState.index,
    rows: state.crudSegmentState.max,
    totalRecords: state.crudSegmentState.count,
    sortField: state.crudSegmentState.sortField,
    order: state.crudSegmentState.sortOrder
  }
}
const mapDispatchToProps = dispatch => {
  return {
    paginate: paginationParams => dispatch(actions.paginate(paginationParams)),
    sortOrder: sortParams => dispatch(actions.sortOrder(sortParams)),
    applyFilter: filterParams => {
      dispatch(actions.setType(null));
      dispatch(actions.applyFilter(filterParams))
    },
    load: () => dispatch(actions.load())
  }
}


class SegmentListPageContainer extends React.Component {

  newHandler = () => {
    this.props.history.push(`${routes.PATH_SEGMENT}/novo`)
  }
  
   
  componentDidMount(){
    this.props.load();
    AppService.on(COMPANY_CHANGE_EVENT_NAME,this);
    AppService.on(BUSINESS_UNIT_CHANGE_EVENT_NAME, this);
  }
  componentWillUnmount(){
    AppService.off(COMPANY_CHANGE_EVENT_NAME,this);
    AppService.off(BUSINESS_UNIT_CHANGE_EVENT_NAME, this);
  }
  
  onReceiveAppNotifications = (eventName, params)=>{
    if(eventName === COMPANY_CHANGE_EVENT_NAME || eventName === BUSINESS_UNIT_CHANGE_EVENT_NAME){
      this.props.load();
    }
  }


  onPage = (e) => {
    this.props.paginate({
      max: e.rows,
      index: e.first
    })
  }
  onSort = (e) => {
    console.log('sorting', e);
    this.props.sortOrder({
      sortOrder: e.sortOrder,
      sortField: e.sortField
    })


  }
  onFilter = (e) => {
    console.log(e);
    const filters = [];
    const keys = Object.keys(e.filters) || [];
    keys.forEach(key => {
      filters.push({
        campo: key,
        valor: e.filters[key].value,
        tipoFiltro: 'CONTEM'

      })
    })
    console.log(filters);
    this.props.applyFilter(filters)
  }

  render() {
    const header = (
      <div>
        <h1>Segmentos</h1>
        <div>
          <Toolbar onNew={this.newHandler} newButtonStyle='highlighted'>
          </Toolbar >
        </div>
      </div>
    );
    const oidTemplate = (rowData, column) => {
      return (
        <div className="id-link"><Link to={`${routes.PATH_SEGMENT}/${rowData.oid}`}>{rowData.oid}</Link></div>
      )
    }

    const columns = this.props.columns.map(col => {
      if (col.field === 'oid') {
        return (<Column {...col} key={col.field} body={oidTemplate} />);
      }
      return (<Column {...col} key={col.field} />)
    })

    const content = <SegmentList  {...this.props} onFilter={this.onFilter} onPage={this.onPage} onSort={this.onSort} columns={columns} />;
    return <Page header={header} content={content} />;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SegmentListPageContainer);
